var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccessibilityBabyChangingFacility = function SvgAccessibilityBabyChangingFacility(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 30 30"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 14.839,
    cy: 4.049,
    r: 3.101
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M14.84 9.094h3.355c.343 0 .671.136.914.378l5.54 5.7a1.29 1.29 0 0 1 0 1.828l-.06.057a1.293 1.293 0 0 1-1.746-.035l-4.045-3.9a.135.135 0 0 0-.232.097v3.247m.146 2.446 3.088 3.493c.518.53.536 1.372.04 1.923l-3.495 4.254a1.408 1.408 0 0 1-2.154-1.81l2.464-2.828-2.4-2.562"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M15.158 9.094h-3.353c-.343 0-.672.135-.915.378l-5.539 5.7a1.29 1.29 0 0 0 0 1.828l.06.057c.503.442 1.26.427 1.746-.035l4.045-3.9a.135.135 0 0 1 .232.097v3.247m3.575.008h-2.906a1.275 1.275 0 0 0-.881 2.196l2.764 2.638c.238.224.552.349.879.348h.276c.327 0 .641-.124.879-.348l2.764-2.638a1.275 1.275 0 0 0-.881-2.196zm-3.718 2.438L8.2 22.405a1.41 1.41 0 0 0-.038 1.923l3.496 4.254a1.41 1.41 0 0 0 1.953.138c.58-.491.666-1.353.195-1.948l-2.461-2.832 2.4-2.561"
  }))));
};
export default SvgAccessibilityBabyChangingFacility;